import { useQuery } from '@tanstack/react-query'
import { useParseQuery } from '../../../../hooks/useNav'

import { errorKeys, PAGE_SIZE } from '../../../../data/queryFactories'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
import { errorService } from '../../../../service/ErrorService'

function mapErrorData(data) {
  return {
    uuid: data.uuid || null,
    studentId: data.studentId || null,
    content: data.content || null,
    device: data.device || null,
    responseEmail: data.responseEmail || null,
    status: data.status || null,
    createdAt: data.createdAt || null,
    createdBy: data.createdBy || null,
    updatedAt: data.updatedAt || null,
    updatedBy: data.updatedBy || null,
  }
}

export default function useGetErrors() {
  const { queryParams } = useParseQuery()
  const { data, isLoading, error } = useQuery({
    queryFn: async () => {
      showLoadingToast('Đang tải', toastKey.ERROR_REPORTS.GET)
      const pageNumber = parseInt(queryParams?.pageNumber - 1) || 0
      const { success, message } = await errorService.search({
        ...queryParams,
        pageNumber,
      })

      if (!success) {
        throw new Error('Khong thể tải về báo lỗi')
      }

      if (message && message.content) {
        showSuccessToast(
          'Tải tất cả báo lỗi thành công',
          toastKey.ERROR_REPORTS.GET
        )

        return {
          pageNumber: parseInt(queryParams?.pageNumber) || 1,
          pageSize: PAGE_SIZE || 10,
          totalItems: message.content.total,
          errors: (message?.content?.items ?? []).map((item) =>
            mapErrorData(item)
          ),
        }
      }

      throw new Error('Dữ liệu không hợp lệ')
    },
    queryKey: errorKeys.list(queryParams),
  })

  if (error) {
    showErrorToast({
      error: error.message,
      message: 'Lấy thông tin thất bại, vui lòng liên hệ admin',
      toastId: toastKey.ERROR_REPORTS.GET,
    })
  }

  return {
    data: data || { pageNumber: 1, errors: [], totalItems: 0 },
    isLoading,
  }
}
